module.exports = __webpack_public_path__ + "img/icon_selected_fill.72f3a699.svg";